import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import About from './components/About';
import SystemicPsychotherapy from './components/SystemicPsychotherapy';
import Pricelist from './components/Pricelist';
import Contact from './components/Contact';
import Psychology from './components/Psychology';
import Fields from './components/Fields';
import './App.css';

function App() {
  return (
    <Router>
      <div className="pt-6">
        <Header />
        <div>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/psychotherapy" element={<SystemicPsychotherapy />} />
            <Route path="/psychology" element={<Psychology />} />
            <Route path="/pricelist" element={<Pricelist />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fields" element={<Fields />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
